var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"view max-w-half"},[_c('div',{staticClass:"content pad"},[(_vm.about.english)?_c('blocks',{attrs:{"content":JSON.parse(_vm.about.english)}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }